<script lang="ts" setup>
import { IGNORE_LEFT_SIDEBAR_URL_NAME, IGNORE_HEADER_FOOTER } from '~/configs'
import { WINDOW_WIDTH_RESIZE } from '~/constants'
import { useCommonStore } from '~/stores/common'
import { useTimeOnPage } from '~/composables/tracking-events/use-time-on-page'
import { useCasinoProvider } from '~/composables/game/use-casino-provider'
import { useFilterGame } from '~/composables/game/use-filter'

const commonStore = useCommonStore()
const { isLobbyGameFilter, isLiveCasinoFilter } = useFilterGame()
const { EVENT_ENABLE } = useRuntimeConfig().public
const $isLighthouseBot = useNuxtApp().$isLighthouseBot as boolean

const route = useRoute()
const { isLogged } = useUser()
const { fetchFavoriteGamesByUser } = useFavoriteGames()
const { casinoProviders, setCasinoProvider } = useCasinoProvider()
const { fetchCasinoProviders } = useCasino({
  gameLimit: 0,
})
useSyncAuthenticateDataTab()
useTimeOnPage()

onMounted(() => {
  setTimeout(async () => {
    if (!casinoProviders.value?.length) {
      const data = await fetchCasinoProviders({})
      if (data?.length) {
        setCasinoProvider(data.filter((item) => item.count > 0))
      }
    }
  })
  fetchFavoriteGamesByUser()
})

watch(
  () => isLogged.value,
  () => {
    fetchFavoriteGamesByUser()
  },
)

const isClosedSidebar = computed({
  get: () => commonStore.isClosedSidebar,
  set: (value) => {
    commonStore.updateClosedSidebar(value)
  },
})

const isSidebarMenu = computed(() => {
  return !IGNORE_LEFT_SIDEBAR_URL_NAME.includes(route.path.split('/')?.[1])
})

const isHideHeaderFooter = computed(() => {
  return !IGNORE_HEADER_FOOTER.includes(route.path.split('/')?.[1])
})

const resizeMenuBar = (): void => {
  if (window) {
    const windowWidth: number = window.innerWidth
    if (windowWidth <= WINDOW_WIDTH_RESIZE) {
      isClosedSidebar.value = true
    }
  }
}

const handleClosedSidebar = () => {
  isClosedSidebar.value = !isClosedSidebar.value
}

onMounted(() => {
  resizeMenuBar()
  window.addEventListener('resize', resizeMenuBar)
})
</script>
<template>
  <main
    :class="[
      'layout',
      {
        'layout--sidebar-closed': isClosedSidebar && isSidebarMenu,
      },
    ]"
  >
    <div class="layout-wrapper">
      <DesktopHeader
        v-if="isHideHeaderFooter"
        :is-show-sidebar="isSidebarMenu"
        @toggle-sidebar="handleClosedSidebar"
      />
      <div class="layout__container body-container">
        <div v-if="isSidebarMenu" class="layout__sidebar" />
        <div class="layout__content">
          <div class="content-page content-page--full-content">
            <div class="page-wrapper">
              <DesktopPagesLobbyGameFilter v-if="isLobbyGameFilter" />
              <DesktopPagesLiveCasinoFilter v-if="isLiveCasinoFilter" />
              <slot />
            </div>
          </div>
        </div>
      </div>
      <DesktopFooter
        v-if="isHideHeaderFooter"
        :is-show-sidebar="isSidebarMenu"
      />
    </div>
    <DesktopCommonSidebar v-if="isSidebarMenu" v-model="isClosedSidebar" />
    <ClientOnly>
      <ModalEventWelcome v-if="EVENT_ENABLE && !$isLighthouseBot"/>
      <CommonToastContainer />
      <DesktopCommonContact />
      <EventDrawingLotsCommonFloating />
    </ClientOnly>
  </main>
</template>
<style lang="scss">
@import '~/assets/styles/components/layouts/desktop.scss';
</style>
